export default "__VITE_ASSET__1UyWCO6e__"